<template>
  <div class="event-container">
    <div class="event-item" v-for="(event, index) of events"
         :key="event.id">
      <div class="text-with-line-center text-with-line_blue-bg">
        <span>{{timestampToData(event.created_at)}}</span>
      </div>
      <div class="event">

        <div class="event-head">
          <div class="items">

            <div class="item">
              <eventTypeIcon />
              <p class="event-name text">
                <trim-item class="fs15"
                           :string="event.type"
                           :offset="90"
                           :width="1"></trim-item>
              </p>
            </div>

<!--            <div class="item name-item"-->
<!--                 v-if="!isVirtualThing">-->
<!--              <thingIcon />-->
<!--              <p class="thing text">-->
<!--                <trim-item :string="thingName" :width="25"></trim-item>-->
<!--              </p>-->
<!--            </div>-->
            <div class="item name-item">
              <thing-icon></thing-icon>
              <p class="thing text">
                <trim-item :string="returnThingName(event)" :width="1"></trim-item>
              </p>
            </div>
          </div>
          <div class="date">
            <!--09 октября 17:17-->
            {{timestampToDataWithTime(event.created_at)}}
          </div>
        </div>

        <div class="event-footer">
          <div class="edit-note"
               v-if="event.status == 1 && event.confirmed_by">{{$t('journal.acknowledged')}}
            {{findRole(event.confirmed_by).user.first_name}}
            <span v-if="findRole(event.confirmed_by).user.second_name">{{findRole(event.confirmed_by).user.second_name}}</span>
          </div>
          <button type="button"
                  v-if="event.status !== 1"
                  :disabled="thing.permission_level < 2"
                  @click="confirm(event.id)"
                  class="btn btn-blue">
            {{$t('journal.acknowledge')}}
          </button>
<!--          <pre>{{event}}</pre>-->
          <p v-if="thing.permission_level < 2 && event.status !== 1" class="edit-note edit-note-left">{{$t('journal.acknowledgedText')}}</p>

          <button type="button"
                  v-if="isOwner"
                  class="control-item_group del-item hint-cont"
                  @click="checkDel(event.id)">
            <span  class="btn-hint btn-hint_bottom ">
              {{$t('index.journal.edit.deleteEvent')}}
            </span>
            <remBtnNoBG />
          </button>
        </div>


      </div>

      <div v-if="getEventContent(event).textBlock === true"
           class="event-block textarea-wrap">
        <div class="event-block-head"
             v-if="!event.edit">
          {{getEventContent(event).eventTitle}}
        </div>
        <div v-html="getEventContent(event).textContent"
             v-if="!event.edit"
             class="event-block-text editor-content">
        </div>
        <button @click="showEditEvent(event.id, event, index)"
                v-if="!event.edit && thing.permission_level > 1"
                class="edit-button">
          <editIcon /> {{$t('index.journal.edit.editDescription')}}
        </button>
        <edit-description @cancel="closeEditEvent(event.id)"
                          @save="saveEdit($event, event.id)"
                          :title="getEventContent(event).eventTitle"
                          :content="getEventContent(event)"
                          :eventId="event.id"
                          v-if="event.edit">
        </edit-description>
      </div>

      <div v-if="getEventContent(event).commentsBlock === true"
           class=" comments-block-full">
        <div class="comments-head">
          <div class="comments"><span>{{event.comments.length}}</span>
            {{returnLabelComment(event.comments.length)}}
          </div>
          <button @click="showAddComment(event, index)"
                  v-if="!event.addComment"
                  class="info-button">
            {{$t('index.journal.addInfoBlock.addButton')}}
            <editIcon />
          </button>
        </div>

        <transition-group name="fade"
                          v-if="event.comments.length"
                          class="comments-body"
                          tag="ul">

          <li class="comment-single"
              :key="comment.id"
               v-for="comment in event.comments">
            <div class="comment-head" v-if="editId !== comment.id">
              <div class="comment-image">
                <div v-if="findRole(comment.author_role_id).user.contacts.avatar_url"
                     :style="{backgroundImage: `url(${findRole(comment.author_role_id).user.contacts.avatar_url})`}"
                     class="avatar-cont">
                </div>
              <user-icon v-else></user-icon>
            </div>

              <div class="comment-info">
                <div class="comment-name">
                  {{findRole(comment.author_role_id).user.first_name}}
                  <span v-if="findRole(comment.author_role_id).user.second_name">{{findRole(comment.author_role_id).user.second_name}}</span>
                </div>
                <div class="comment-date">{{timestampToDataWithTime(comment.updated_at)}}</div>
              </div>
            </div>

            <div class="comment-body" v-if="editId !== comment.id">
              <div v-html="getCommentContent(comment.text)"
                   class="event-block-text editor-content">
              </div>
            </div>
            <div class="comment-footer"
                 v-if="(activeRole == comment.author_active_role_id && (editId !== comment.id)) || (user.primary_role_id == comment.author_active_role_id && (editId !== comment.id))">
              <div class="comment-buttons">
                <button @click="showEditComment(event, index, comment)"
                        class="comment-buttons-edit"><editIcon /></button>
                <button  @click="delComment(comment.id)"
                         class="comment-buttons-remove"><remBtnNoBG /></button>
              </div>
            </div>

            <transition name="fade">
<!--              редактирование коммента-->
              <add-comment v-if="event.addComment && (editId === comment.id)"
                           :comment-edit="commentEdit"
                           :edit-id="editId"
                           @cancel="cancelComment(index, event)"
                           @add="addComment(event.id, $event)"
                           @edit="editComment(event.id, $event)"
                           :index="index">
              </add-comment>
            </transition>
          </li>
        </transition-group>

        <transition name="fade">
<!--          новый коммент-->
          <add-comment v-if="event.addComment && !editId"
                       :comment-edit="commentEdit"
                       @cancel="cancelComment(index, event)"
                       @add="addComment(event.id, $event)"
                       :index="index">
          </add-comment>
        </transition>
      </div>

      <div v-if="getEventContent(event).enclosureBlock === true"
           class=" attachment-block">
        <div class="attachment-head">
          <div class="comments"><span>{{event.files.length}} </span>
            {{returnLabelAttach(event.files.length)}}</div>
          <label class="info-button" v-if="thing.permission_level > 1">
            <input type="file"
                   multiple
                   @change="addFiles($event, event.id)"
                   accept="image/*, .doc, .docx, .ppt, .pdf, .xlsx">
            {{$t('btns.add')}}
            <clipIcon />
          </label>
        </div>

        <div class="attachment-body"
             v-for="(file, fileIndex) in event.files">
          <div class="top">
            <div class="image-cont"
                 :style="{backgroundImage: `url(${file.file_url})`}"
                 v-if="isImageFile(file.filename)">
            </div>
            <div class="attachment-info">
              <a :href="file.file_url"
              target="_blank"
              download="" class="attachment-name">{{file.filename}}</a>
              <p class="attachment-date">{{timestampToDataWithTime(file.created_at)}}</p>
            </div>

            <div class="attachment-buttons" v-if="activeRole == event.author_role_id">
              <button @click="showEditFile(event,index, file, fileIndex)"
                      class="attachment-buttons-edit"><editIcon /></button>
              <button @click="delFile(file.id)"
                      class="attachment-buttons-remove"><remBtnNoBG /></button>
            </div>
          </div>
          <transition-group name="fade">
            <rename-file :file-name="fileEdit"
                         @save="renameFile(file.id, $event)"
                         @cancel="cancelRename(index, fileIndex)"
                         v-if="file.renameFile"></rename-file>
          </transition-group>
        </div>

        <upload-file @upload="addFile($event,event.id)" v-if="thing.permission_level > 1"></upload-file>
      </div>

    </div>
  </div>
</template>

<script>
  import thingIcon from '../../../components/Svg/journal/thingIcon'
  import eventTypeIcon from '../../../components/Svg/journal/eventTypeIcon'
  import remBtnNoBG from '../../../components/Svg/journal/remBtnNoBG'
  import editIcon from '../../../components/Svg/journal/editIcon-2'
  import clipIcon from '../../../components/Svg/journal/clipIcon-2'
  import errors from '../../Forms/errors'
  import {singleSettings} from "../../../mixins/things/singleSettings";
  import {filters} from "../../../mixins/filters";
  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
  import addComment from './comments/addComment'
  import {tokenAndRoute} from "../../../mixins/utils/tokenAndRoute";
  import userIcon from '../../../components/Svg/users/user'
  import uploadFile from './uploadFile'
  import renameFile from './renameFile'
  import editDescription from './editDescription'
  import {delItem} from "../../../mixins/delItem";
  import delIcon from '../../../components/Svg/cart_control/delIcon'
  import {showOverlay} from "../../../mixins/utils/showOverlay";
  import trimItem from '../../../components/trimITem'
  import {editorConfig} from "@/mixins/editorConfig";

  export default {
    name: "event",
    mixins: [singleSettings, filters, tokenAndRoute, delItem, showOverlay, editorConfig],
    components: {
      addComment,
      thingIcon,
      eventTypeIcon,
      remBtnNoBG,
      editIcon,
      clipIcon,
      errors,
      userIcon,
      uploadFile,
      renameFile,
      editDescription,
      delIcon,
      trimItem,
    },
    props: {
      events: {
        type: [Object, Array]
      }
    },
    data: () => ({
      avatarFile: '',
      avatarChanged: false,
      avatarDel: false,

      commentEdit: '',
      editId: '',

      fileEdit: '',
      filedEditId: '',

      delId: '',
      // createNewComment: false
    }),
    computed: {
      ...mapState({
        thing: state => state.things.device,
        eventsRoles: state => state.journal.eventsRoles,
        user: state => state.auth.user
      }),
      ...mapGetters({
        activeRole: 'auth/activeRole',
      }),
      isVirtualThing() {
        return !!this.thing.virtual
      },
      thingName() {
        return this.thing.name
      },
      ownersList() {
        if (this.thing) {
          let arr = this.thing.permissions.filter(item => {
            return item.value > 3
          });
          arr.push({
            role_id: this.thing.owner.user.primary_role_id
          });
          return arr
        }
      },
      isOwner() {
        if (this.ownersList) {
          for (let item of this.ownersList) {
            if (this.activeRole == item.role_id) {
              return true;
            }
          }
        }
        return false
      },
      bgLabel() {
        if (!this.fileImg) {
          return this.oldImg
        } else {
          return this.fileImg;
        }
      },
    },
    methods: {
      ...mapActions({
        getEvents: 'journal/getEvents',
        addEventComment: 'journal/addEventComment',
        deleteEventComment: 'journal/deleteEventComment',
        updateEventComment: 'journal/updateEventComment',
        addEventFiles: 'journal/addEventFiles',
        deleteEventFile: 'journal/deleteEventFile',
        renameEventFile: 'journal/renameEventFile',
        confirmEvent: 'journal/confirmEvent',
        updateEvent: 'journal/updateEvent',
        deleteEvent: 'journal/deleteEvent'
      }),
      ...mapMutations({
        setAddComment: 'journal/SET_ADD_COMMENT',
        setRenameFile: 'journal/SET_RENAME_FILE',
        setEditEvent: 'journal/SET_EDIT_EVENT'
      }),
      isImageFile(name) {
        return name.includes('jpg') || name.includes('png') || name.includes('gif')
      },
      returnThingName(event) {
        let name = '';
        let id = event.source_device_id

        if (event.device_data && event.device_data.name) {
          return event.device_data.name
        }

        if (this.thing.id == id) {
          name = this.thing.name
          return name
        }
        let deviceFunc = (devices) => {
          devices.forEach((item) => {
            if (item.id == id) {
              name = item.name
            }
            if (item.devices.length > 0) {
              deviceFunc(item.devices)
            }
          })
        }
        if (this.thing && this.thing.devices.length > 0) {
          this.thing.devices.forEach((item) => {
            if (item.id == id) {
              name = item.name
            }
            if (item.devices.length > 0) {
              deviceFunc(item.devices)
            }
          })
        }
        return name
        let things = this.thing.devices;
        for (let device of things) {
          if (id == device.id) {
            return device.name
          }
        }
      },
      findRole(id) {
        let role = '';
        for (let roleKey in this.eventsRoles) {
          let item = this.eventsRoles[roleKey];
          if (item.id == id) {
            return role = item
          }
        }
      },
      checkDel(id) {
        this.showOverlay(true);
        this.showDelPopup(true);
        this.delId = id
      },
      async deleteItems() {
        await this.deleteEvent({id: this.delId});
        this.delId = '';
        this.getEvents({id: this.routeId});

      },
      showEditEvent(id, event , index) {
        this.setEditEvent({id, marker: true})
        this.setAddComment({index, marker: false, event})
        this.editId = ''
      },
      async saveEdit(evt, id) {
        await this.updateEvent({
          id,
          content: JSON.stringify(evt),
          title: JSON.stringify(evt.eventTitle),
          text: JSON.stringify(evt.textContent),
        });
        await this.getEvents({id: this.routeId});
      },
      closeEditEvent(id) {
        this.setEditEvent({id, marker: false})
      },
      async confirm(id) {
        await this.confirmEvent({id});
        this.getEvents({id: this.routeId});
      },
      addFiles(e, id) {
        let files = e.target.files;
        this.addFile(files, id);
      },
      async delFile(id) {
        await this.deleteEventFile({id});
        this.getEvents({id: this.routeId});
      },
      showEditFile(event,index, file, fileIndex) {
        this.fileEdit = file.filename;
        this.filedEditId = file.id;

        this.setRenameFile({index, fileIndex, marker: true})
      },
      cancelRename(index, fileIndex) {
        this.setRenameFile({index, fileIndex, marker: false})
      },
      async renameFile(id, name) {
        await this.renameEventFile({id, name});
        this.getEvents({id: this.routeId});
      },
      async addFile(files, id) {
        let obj = {
          id,
        };
        let formData = this.toFormData(obj);
        files.forEach((file,index) => {
          formData.append(`files[${index}]`, file)
        });
        await this.addEventFiles(formData);
        await this.getEvents({id: this.routeId});
      },

      returnLabelComment(length) {
        length = String(length).slice(-1);

        if (length == 0 || length >= 5) {
          return this.$t('journal.comment0')
        };

        if (length == 1) {
          return this.$t('journal.comment1')
        };

        if (length > 1 && length < 5) {
          return this.$t('journal.comment2')
        }
      },
      returnLabelAttach(length) {
        length = String(length).slice(-1);

        if (length == 0 || length >= 5) {
          return this.$t('journal.attach0')
        };

        if (length == 1) {
          return this.$t('journal.attach1')
        };

        if (length > 1 && length < 5) {
          return this.$t('journal.attach2')
        }
      },
      findCommentOwner(comment,event) {
        return  this.findRole(comment.role_id);
      },
      showEditComment(event, index, comment) {
        this.commentEdit = comment.text;
        this.editId = comment.id;
        this.showAddComment(event, index, comment);
        setTimeout(() => {
          this.commentEdit = '';
          // this.editId = '';
          this.customText = ''
        }, 300)
      },
      showAddComment(event, index, comment) {
        if (!comment) this.editId = false

        this.setAddComment({index, marker: true, event})
        this.setEditEvent({id: event.id, marker: false})
      },
      cancelComment(index, event) {
        this.setAddComment({index, marker: false, event})
        this.editId = false
        this.customText = ''
      },
      async addComment(id, comment) {
        this.customText = ''
        // this.editId = comment.id;
        await this.addEventComment({
          event_id: id,
          text: comment,
        });
        await this.getEvents({id: this.routeId});
      },
      async editComment(id, comment) {
        this.customText = ''
        this.editId = comment.id;
        await this.updateEventComment({
          id: comment.id,
          text: comment.comment
        });
        await this.getEvents({id: this.routeId});
      },
      async delComment(id) {
        await this.deleteEventComment({id})
        await this.getEvents({id: this.routeId});
      },
      uploadEnclosure(file) {
        this.avatarFile = file;
        this.avatarChanged = true
      },
      delEnclosure() {
        this.avatarFile = '';
        this.avatarDel = true
      },
      getEventContent(event) {
        return JSON.parse(event.content)
      },
      getCommentContent(text) {
        return text
      },
    },
    mounted() {}
  }
</script>

<style lang="scss">
  .info-block, .event-footer, .comments-block-full, .attachment-block, .event-block {
    .info-button, .edit-button {
      svg path {
        transition: all .3s;
      }
      &:hover {
        color: $green;
        svg path {
          fill: $green;
        }
      }
    }
  }
  .edit-button:hover {
    color: $green;
  }
  .attachment-buttons .attachment-buttons-edit, .comment-buttons .comment-buttons-edit {
    svg path {
      transition: all .3s;
    }
    &:hover {
      color: $green;
      svg path {
        fill: $green;
      }
    }
  }
  .attachment-buttons .attachment-buttons-remove, .comment-buttons .comment-buttons-remove, .control-item_group {
    svg path {
      transition: all .3s;
    }
    &:hover {
      color: $red;
      svg path {
        fill: $red;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .drug-field {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 220px;
    box-sizing: border-box;
    transition: $anim;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;

    input {
      display: none;
    }

    img {
      max-width: 61px;
      margin-bottom: 36px;
      opacity: .36;
    }
  }

  .image-cont {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    filter: drop-shadow(0px 4px 12px rgba(0, 82, 127, 0.2));
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    margin-right: 30px;
  }


  .drug-field_error {
    border: 2px solid $red;

    .text-cont {
      .error {
        color: $red;
      }
    }
  }

  .drug-field_loaded {
    border: none;
  }

  .drug-field_active {
    position: relative;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 2;
      background: rgba(16, 156, 241, .15);
    }
  }
</style>

<style lang="scss" scoped>
  .fs15 {
    font-size: 15px;
  }

  .event-container {
    max-width: 800px;
    margin: auto;
  }

  .text-with-line, .text-with-line-center {
    margin: 25px 0;
  }

  .text-with-line_blue-bg span {
    @extend %regularDarkBlue;
  }

  .event {
    margin-bottom: 10px;
    padding: 10px 30px 25px 30px;
    background: #FFFFFF;
    box-shadow: 0 4px 12px rgba(0, 82, 127, 0.2);
    border-radius: 8px;

    .event-head {
      padding: 20px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid $ultraLightBlue;
      .date {
        @extend %regularDarkBlue;
        white-space: nowrap;
      }
    }

    .items {
      display: flex;
    }

    .item {
      display: flex;
      align-items: center;
      &:first-child {
        margin-right: 20px;
      }

      svg {
        margin-right: 5px;
      }
    }

    .text {
      @extend %regularDarkBlue;
    }
    .event-name {
      color: $green;
      max-width: 220px;
    }
    .name-item {
      width: 320px;
    }
  }

  .event-body {
    /*padding: 30px 0 25px 0;*/
    padding-top: 30px;
    .body-heading {
      margin-bottom: 30px;
      color: $darkBlue;
      font-family: $msb;
      font-weight: 600;
      font-size: 24px;
    }

    .body-text {
      color: $darkBlue;
      font-family: $mm;
      font-weight: 500;
      font-size: 13px;
      line-height: 165%;
      padding-bottom: 30px;
      border-bottom: 1px solid $ultraLightBlue;
    }
  }

  .event-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 30px;

    .edit-button {
      display: flex;
      align-items: center;
      @extend %regularLightBlue;
      &:hover {
        color: $green;
      }
      svg {
        margin-right: 10px;
      }
    }

    .edit-note {
      @extend %regularDarkBlue;
      color: rgba(0 ,82, 127, .6);
    }

    .edit-note-left {
      margin-left: 20px;
      margin-right: auto;
    }
  }
  .btn {
    max-width: 200px;
  }
  .btn-blue {
    margin-left: 20px;
  }

  .info-block {
    @extend %regularDarkBlue;
    display: flex;
    justify-content: space-between;
    padding: 19px 30px;
    background: #FFFFFF;
    border-radius: 8px;
    margin-bottom: 10px;
  }

  .info-button {
    display: flex;
    align-items: center;
    @extend %regularLightBlue;
    cursor: pointer;

    svg {
      margin-left: 10px;
    };

    input {
      position: absolute;
      z-index: -99;
      opacity: 0;
      width: 0;
      height: 0;
    }
  }
  //----------single drag n drop block
  .add-attachment {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100px;
    background-color: rgba(0 ,82, 127, .1);
    font-family: $mm;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    margin-bottom: 10px;
  }
  //----------attachment open/active
  .attachment-block {
    width: 100%;
    margin-bottom: 10px;
  }
  .attachment-head, .comments-head {
    @extend %regularDarkBlue;
    display: flex;
    justify-content: space-between;
    padding: 19px 30px;
    background: #FFFFFF;
    border-radius: 8px 8px 0 0;
  }
  .attachment-body {
    padding: 30px;
    background-color: rgba(255, 255, 255, .7);
    border-radius: 0 0 8px 8px;


    .top {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
  .attachment-image {
    width: 80px;
    height: 80px;
    margin-right: 30px;
  }
  .attachment-name {
    @extend %regularDarkBlue;
    margin-bottom: 6px;
  }
  .attachment-date {
    font-family: $mm;
    font-size: 10px;
    line-height: 12px;
    color: rgba(0 ,82, 127, .6);
  }
  .attachment-buttons {
    margin-left: auto;
    svg {
      margin-left: 10px;
    }
  }
  //----------comments open/active
  .comments-block-full {
    width: 100%;
    margin-bottom: 40px;
  }
  .comments-body {
    padding: 30px 30px 15px 30px;
    background-color: rgba(255, 255, 255, .7);
    border-radius: 0 0 8px 8px;
    margin-top: -30px;
    margin-bottom: -30px;
  }
  .comment-single {
    margin: 30px 0;
  }
  .comment-head {
    display: flex;
    margin-bottom: 20px;

    .comment-image {
      width: 46px;
      height: 46px;
      margin-right: 14px;
      display: flex;
      justify-content: center;
      align-items: center;

      .avatar-cont {
        border-radius: 50%;
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }

      svg {

      }
    }
    .comment-name {
      @extend %regularDarkBlue;
      margin-bottom: 6px;
    }
    .comment-date {
      font-family: $mm;
      font-size: 10px;
      line-height: 12px;
      color: rgba(0 ,82, 127, .6);
    }
    .comment-info {
      height: 46px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
    }

  }
  .comment-body {
    @extend %regularDarkBlue;
    font-size: 13px;
    line-height: 165%;
    padding-left: 60px;
    margin-bottom: 10px;
  }
  .comment-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-left: 60px;
    .answer {
      font-weight: 500;
      font-size: 13px;
      color: rgba(0, 82, 127, 0.4);
    }
    svg {
      margin-left: 10px;
    }
  }

  .thing {
    max-width: 60%;
  }

 .items {
   max-width: calc(100% - 150px);
 }

  .event-block {
    margin-bottom: 10px;
    background: #FFFFFF;
    box-shadow: 0 4px 12px rgba(0, 82, 127, 0.2);
    border-radius: 8px;
    padding: 30px;
    .event-block-head {
      margin-bottom: 30px;
    }
    .edit-button {
      display: flex;
      align-items: center;
      @extend %regularLightBlue;
      &:hover {
        color: $green;
      }
      svg {
        margin-right: 10px;
      }
    }

    .event-block-head {
      margin-bottom: 30px;
      color: $darkBlue;
      font-family: $msb;
      font-weight: 600;
      font-size: 24px;
    }

    .event-block-text {
      color: $darkBlue;
      font-family: $mm;
      font-weight: 500;
      font-size: 13px;
      line-height: 165%;
      margin-bottom: 50px;
    }
  }
</style>
